export default {
	methods: {
		gtag(event) {
			if(typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push(event);
			} else {
				console.log(event);
			}
		}
	}
}